export const BASE_URL = "https://api.thepaygram.com/merchants/v1";
export const ADMIN_BASE_URL = "https://api.thepaygram.com/admin/v1";
export const CLIENT_BASE_URL = "https://api.thepaygram.com/api/v1";
